import { render } from "./NewSidenav.vue?vue&type=template&id=253b0716&scoped=true"
import script from "./NewSidenav.vue?vue&type=script&lang=js"
export * from "./NewSidenav.vue?vue&type=script&lang=js"

import "./NewSidenav.vue?vue&type=style&index=0&id=253b0716&scoped=true&lang=css"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-253b0716"]])

export default __exports__